import React, { useEffect } from 'react'
import {
  Outlet,
  useParams,
} from 'react-router-dom/dist/umd/react-router-dom.development'
import useMineralsActions from '../hooks/useMineralsActions'

export default function LayoutMineral() {
  const { mineral_id } = useParams()
  const { getMineral } = useMineralsActions()

  useEffect(() => {
    getMineral(mineral_id)
  }, [mineral_id])

  return <Outlet />
}
